import React from 'react'
import {
  FormControl, FormHelperText, Grid, TextField, Typography
} from '@material-ui/core';
import { ChromePicker } from 'react-color';
import CKEditor from 'ckeditor4-react';
import { showDeveloperMessageConsole } from 'src/helpers/random';
import ItemBtns from './agrupadors-item-btns';

import configCKEditor from 'src/config/ckeditor';
import Switch from '@material-ui/core/Switch';


const CKEditorConfigForItemText = {
  height: 150,
  toolbar: [
    { name: 'basicstyles', items: ['Bold', 'Italic'] },
    { name: 'styles', items: ['TextColor', 'FontSize', 'Font'] },
    { name: 'alignment', items: ['JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock'] },
    { name: 'links', items: ['Link', 'Unlink'] },
    { name: 'editing', items: ['Find', 'Replace', 'SelectAll', '-', 'Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo'] },
  ],
}

const SubformItemsAgrupadorItem = ({ index, touched, errors, values, swap, remove, handleBlur, handleChange, setFieldValue, setFieldTouched }) =>
{
  const textErrorShouldShow = Boolean((touched.item && errors.item) && touched.item[index]?.text && errors.item[index]?.text);
  const divURLErrorShouldShow = Boolean((touched.item && errors.item) && touched.item[index]?.divURL && errors.item[index]?.divURL);
  const iconURLErrorShouldShow = Boolean((touched.item && errors.item) && touched.item[index]?.iconURL && errors.item[index]?.iconURL);

  return (
  <Grid container key={index}>
    <Grid item xs={12} md={6} className="px-3 py-3 my-2 border">

      <div>
        <h6>
          ITEM {index+1}
        </h6>
        <ItemBtns
          index={index}
          swap={swap}
          remove={remove}
          values={values}
        />
      </div>

      {/* ▼ TEXTO DEL ITEM */}
      <Typography color="textPrimary" variant="overline">Texto</Typography>
      <CKEditor
        id={`item.${index}.text`}
        name={`item.${index}.text`}
        data={values.item[index].text}
        config={{...configCKEditor, ...CKEditorConfigForItemText}}
        onNamespaceLoaded={(CKEDITOR) =>
        {
        }}
        onInstanceReady={(e) =>
        {
        }}
        onChange={(e) =>
        {
            setTimeout(()=>{setFieldValue(`item.${index}.text`, e.editor.editable().getData())}, 0);
        }}
        onBlur={(e) =>
        {
          setFieldTouched(`item.${index}.text`);
        }}
        onError={(e) => showDeveloperMessageConsole('Error: ', e)}
      />
      <FormHelperText className="text-danger">
        {textErrorShouldShow && errors.item[index]?.text}
      </FormHelperText>

      {/* ▼ ENLACE para el contenedor del item. */}
      <TextField
        error={divURLErrorShouldShow}
        fullWidth
        helperText={divURLErrorShouldShow && errors.item[index]?.divURL}
        label="Enlace para contenedor del item."
        margin="normal"
        name={`item.${index}.divURL`}
        onBlur={handleBlur}
        onChange={e => {setFieldValue(e.target.name, e.target.value.trim())}}
        type="text"
        value={values.item[index].divURL}
        variant="outlined"
      />
      {/* ▼ TOOGLER p/abrir enlace en otra pestaña */}
      <Switch
        checked={values.item[index].willTargetBlank}
        onChange={handleChange}
        name={`item.${index}.willTargetBlank`}
        inputProps={{ 'aria-label': 'primary checkbox' }}
      />
      <h6 className='d-inline'>Abrir URL en pestaña nueva</h6>

      {/* ▼ ENLACE para icono de descarga del item. */}
      <TextField
        error={iconURLErrorShouldShow}
        fullWidth
        helperText={iconURLErrorShouldShow && errors.item[index]?.iconURL}
        label="Enlace icono de descarga"
        margin="normal"
        name={`item.${index}.iconURL`}
        onBlur={handleBlur}
        onChange={e => {setFieldValue(e.target.name, e.target.value.trim())}}
        type="text"
        value={values.item[index].iconURL}
        variant="outlined"
      />

      {/* ▼ COLOR DE FONDO EN DIV DEL ITEM */}
      <Grid container>
        <Grid item xs={12} md={6} className="py-2">
          <FormControl fullWidth error={Boolean(touched.instWeb && errors.instWeb)}>
            <ChromePicker
              width="60%"
              color={values.item[index].bgColor || '#D6D8D9'}
              onChangeComplete={(color) => setFieldValue(`item.${index}.bgColor`, color.hex)}
            />
          </FormControl>
        </Grid>
      </Grid>

    </Grid>
  </Grid>
  )
}

export default SubformItemsAgrupadorItem;
